export default __webpack_public_path__ + "static/media/coin.d0307b11.webp";